import {
	Directive,
	ElementRef,
	Renderer2,
	Input,
	NgZone,
	HostListener
} from '@angular/core';

@Directive({ selector: '[appResize]' })
export class ResizeDirective {
	constructor(private ngZone: NgZone, private el: ElementRef, private renderer: Renderer2) {}
	@HostListener('window:resize', ['$event'])
	onResize(event) {
		// ngZone.run will help to run change detection
		this.ngZone.run(() => {
			console.log('Width: ' + window.innerWidth);
			if (window.innerWidth <= 768) {
				console.log('Small screen');
				this.renderer.addClass(this.el, 'small-screen');
			} else {
				this.renderer.removeClass(this.el, 'small-screen');
			}
		});
	}
}
